<template>
    <h3 class="text-xl text-gray-800 mt-8 mb-4 font-bold">Breadcrumb</h3>
    <nav class="bg-grey-light rounded font-sans w-full">
        <ul>
            <li class="mt-8"><a href="#" class="text-gray-500">Breadcrumb /</a></li>
            <li class="mt-8"><a href="#" class="underline text-blue-800">Breadcrumb /</a></li>
            <li class="mt-8"><a href="#" class="font-bold">Breadcrumb /</a></li>
            <li class="mt-8"><a href="#" class="text-gray-500">...</a></li>
            <li class="mt-8"><a href="#" class="border-4 border-blue-500 text-gray-400">Breadcrumb /</a></li>
        </ul>
    </nav>
</template>